/**
 * Noting that there are two functions on purpose here:
 * One for components that are shared between the reopen flow and the normal flow (since they may onmit type)
 * One for components that are only in the reopen flow (since they always have a type)
 */
type ReopenFlowType = 'long_reopen' | 'short_reopen'

// Shared components that may not have reopen context
export function reopenFlowTypeAnalyticsProps(
  isLongReopen?: boolean,
): { type: ReopenFlowType } | Record<string, never> {
  if (isLongReopen === undefined) {
    return {}
  }
  return {
    type: isLongReopen ? 'long_reopen' : 'short_reopen',
  }
}

// Components that are only in the reopen flow
export function reopenFlowTypeInReopenFunnel(
  isLongReopen?: boolean,
): ReopenFlowType {
  return isLongReopen === true ? 'long_reopen' : 'short_reopen'
}
